"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TokenRoutes = void 0;
/**
 * An Online token routes dictionary
 */ var TokenRoutes = exports.TokenRoutes = /*#__PURE__*/ function(TokenRoutes) {
    /**
   * Online route that returns public token when user is not logged in
   */ TokenRoutes["PUBLIC_ACCESS"] = "/system/ajax/ApiGateway/GetSpaTokenAsync";
    /**
   * Online route that returns user token when user is logged in, otherwise the request ends with http status code `403`
   */ TokenRoutes["USER_ACCESS"] = "/system/ajax/ApiGateway/GetUserAccessTokenAsync";
    return TokenRoutes;
}({}); //# sourceMappingURL=TokenRoutes.js.map
